import React from "react";
import { Form, Checkbox, Radio, Input, Select, Row, Col } from "antd";

const Section4 = ({ formValues, setFormValues }) => (
  <Form layout="vertical">
    {/* Q13 – Have you ever spent money on advertising? */}
    <Form.Item label="13. Have you ever spent money on advertising or promotion?">
      <Radio.Group
        value={formValues.hasSpent}
        onChange={(e) =>
          setFormValues({ ...formValues, hasSpent: e.target.value })
        }
      >
        <Radio value="Yes">Yes</Radio>
        <Radio value="No">No</Radio>
      </Radio.Group>
    </Form.Item>

    {/* If YES → Show Q14–Q17 */}
    {formValues.hasSpent === "Yes" && (
      <>
        {/* Q14 – Types of advertising used */}
        <Form.Item label="14. What types of advertising have you used? (Check all that apply)">
          <Checkbox.Group
            style={{ width: "100%" }}
            value={formValues.adTypes || []}
            onChange={(checked) =>
              setFormValues({ ...formValues, adTypes: checked })
            }
          >
            <Row gutter={[0, 10]}>
              {[
                "Social media ads",
                "Radio",
                "TV",
                "Print (newspaper, magazine, flyer)",
                "Online banners or search ads",
                "Direct mail",
                "Other",
              ].map((option) => (
                <Col span={12} key={option}>
                  <Checkbox value={option}>{option}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>

          {formValues.adTypes?.includes("Other") && (
            <Input
              placeholder="Please specify other advertising"
              style={{ marginTop: 10 }}
              value={formValues.adTypesOther || ""}
              onChange={(e) =>
                setFormValues({ ...formValues, adTypesOther: e.target.value })
              }
            />
          )}
        </Form.Item>

        {/* Q15 – Why did you choose those channels? */}
        <Form.Item label="15. Why did you choose those channels? (Select all that apply)">
           <Checkbox.Group
            style={{ width: "100%" }}
            value={formValues.adReasons || []}
            onChange={(checked) =>
              setFormValues({ ...formValues, adReasons: checked })
            }
          >
            <Row gutter={[0, 10]}>
              {[
                 "Affordability",
                  "Recommendation by others",
                  "Competitors’ use",
                  "Target-audience fit",
                  "Prior success",
                  "Ease of setup",
                  "Other",
              ].map((option) => (
                <Col span={12} key={option}>
                  <Checkbox value={option}>{option}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>     
          
          {formValues.adReasons?.includes("Other") && (
            <Input
              placeholder="Please specify other reason"
              style={{ marginTop: 8 }}
              value={formValues.adReasonsOther || ""}
              onChange={(e) =>
                setFormValues({ ...formValues, adReasonsOther: e.target.value })
              }
            />
          )}
        </Form.Item>

        {/* Q16 – Did advertising help you reach your goals? */}
        <Form.Item label="16. Did that advertising help you reach your goals?">
          <Radio.Group
            value={formValues.adEffectiveness}
            onChange={(e) =>
              setFormValues({ ...formValues, adEffectiveness: e.target.value })
            }
          >
            <Radio value="Yes">Yes</Radio>
            <Radio value="Somewhat">Somewhat</Radio>
            <Radio value="No">No</Radio>
            <Radio value="Not sure / Didn’t track">
              Not sure / Didn’t track
            </Radio>
          </Radio.Group>
        </Form.Item>

        {/* If YES or Somewhat → show results */}
        {(formValues.adEffectiveness === "Yes" ||
          formValues.adEffectiveness === "Somewhat") && (
          <Form.Item label="What results did you notice? (Select all that apply)">
             <Checkbox.Group
            style={{ width: "100%" }}
            value={formValues.adResults || []}
            onChange={(checked) =>
                setFormValues({ ...formValues, adResults: checked })
              }
          >
            <Row gutter={[0, 10]}>
              {[
                 "More calls or emails",
                "More store or website visits",
                "More social media activity",
                "Greater community awareness",
                "Increased sales",
                "Other",
              ].map((option) => (
                <Col span={12} key={option}>
                  <Checkbox value={option}>{option}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group> 
            
            {formValues.adResults?.includes("Other") && (
              <Input
                placeholder="Please specify other result"
                style={{ marginTop: 8 }}
                value={formValues.adResultsOther || ""}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    adResultsOther: e.target.value,
                  })
                }
              />
            )}
          </Form.Item>
        )}

        {/* If NO → show why it didn’t work */}
        {formValues.adEffectiveness === "No" && (
          <Form.Item label="What do you think didn’t work? (Select all that apply)">
            <Checkbox.Group
              options={[
                "Wrong audience",
                "No activity/sales lift",
                "Too expensive",
                "Ran too briefly",
                "Unsure",
                "Other",
              ]}
              value={formValues.adFailures || []}
              onChange={(checked) =>
                setFormValues({ ...formValues, adFailures: checked })
              }
            />
            {formValues.adFailures?.includes("Other") && (
              <Input
                placeholder="Please specify what didn’t work"
                style={{ marginTop: 8 }}
                value={formValues.adFailuresOther || ""}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    adFailuresOther: e.target.value,
                  })
                }
              />
            )}
          </Form.Item>
        )}

        {/* Q17 – Was the money worth it? */}
        <Form.Item label="17. Do you feel the money you spent was worth it?">
          <Radio.Group
            value={formValues.adWorth}
            onChange={(e) =>
              setFormValues({ ...formValues, adWorth: e.target.value })
            }
          >
            <Radio value="Yes">Yes</Radio>
            <Radio value="Somewhat">Somewhat</Radio>
            <Radio value="No">No</Radio>
            <Radio value="Not sure">Not sure</Radio>
          </Radio.Group>
        </Form.Item>
      </>
    )}

    {/* Q18 – Frequency (always visible, even if NO advertising) */}
    <Form.Item label="18. How often do you run advertising or promotional campaigns?">
      <Select
        placeholder="Select frequency"
        value={formValues.adFrequency}
        onChange={(val) => setFormValues({ ...formValues, adFrequency: val })}
      >
        <Select.Option value="Monthly">Monthly</Select.Option>
        <Select.Option value="Quarterly">Quarterly</Select.Option>
        <Select.Option value="Semiannually">Semiannually</Select.Option>
        <Select.Option value="Annually">Annually</Select.Option>
        <Select.Option value="Less than once a year">
          Less than once a year
        </Select.Option>
        <Select.Option value="No regular schedule">
          No regular schedule
        </Select.Option>
      </Select>
    </Form.Item>
  </Form>
);

export default Section4;
